
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

declare var $: any;


@Component({
    selector: 'app-alert-success-cesion',
    templateUrl: './alert-success-cesion.html',
    styleUrls: ['./alert-success-cesion.less'],
    standalone: false
})
export class AlertSuccessCesion implements OnInit {


  @Input() id_sim:any;
  @Input() id_company:any;
  parent:any;
  sii_lento:boolean=false;

  open_as_sim:boolean=false;

  title:string="¡Cesión realizada con éxito!";
  subtitle:string="Revisa el estado de esta etapa de la operación, con sus datos actualizados."
  solo_cerrar:boolean=false;

  constructor(public dialog: MatDialog, public dialogRef:MatDialogRef<AlertSuccessCesion>, public router:Router) {

    this.id_company = localStorage.getItem('company_id');

   }


  is_responsive:boolean=false;
  ngOnInit() {
    if (window.screen.width <= 1024) {
      this.is_responsive = true;
    }

  }

  ver_estado(){
    if(this.solo_cerrar == false){
      this.dialogRef.close(true);
      this.parent.parent.change_step('step-simpli3');
    }else{
      this.dialogRef.close();
    }

  }

  retry(){
    this.dialogRef.close(true)
  }


}
